import utilsHolder from 'bdata-sns-shared/utils/utilsHolder';

const getTeamUrl = (teamId, urlRoot = '', fallback = '') => {
    const { linker } = utilsHolder;
    if (!linker) {
        return fallback;
    }

    const teamPath = linker.getTeamHomepageLinkFromTeamId(teamId);
    if (!teamPath) {
        return fallback;
    }

    return `${fallback || urlRoot}${teamPath}`;
};

export default getTeamUrl;
